import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ButtonsToggler } from '@login/components/buttons-toggler';

import styles from './marketing-opt-in.module.scss';

export type MarketingOptInLabels = {
	yes: string;
	no: string;
	partnerMessage: string;
	optOutMessage: string;
	transactionalMessage: string;
	requiredError: string;
};

type MarketingOptInProps = {
	labels: MarketingOptInLabels;
	/** Channel-specific opt-in copy returned by the API. */
	marketingMessage?: string;
	name?: string;
};

/**
 * The marketing opt-in yes/no toggle plus its surrounding copy, shared by the
 * register and full-register forms.
 */
const MarketingOptInInner = ({
	labels,
	marketingMessage,
	name = 'marketingOptIn',
}: MarketingOptInProps) => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	return (
		<div className={styles.offerSection}>
			{marketingMessage && (
				<div className="body-small bold">
					<span className={styles.redText}>*</span>
					{marketingMessage}
				</div>
			)}

			<div className={`body-small ${styles.contentSecondaryText}`}>
				{labels.partnerMessage}
			</div>

			<div className={styles.buttonsSection}>
				<Controller
					name={name}
					control={control}
					rules={{
						validate: (value) =>
							value !== undefined || labels.requiredError,
					}}
					render={({ field }) => (
						<ButtonsToggler
							id={name}
							trueLabel={labels.yes}
							falseLabel={labels.no}
							value={field.value}
							errorMessage={
								(errors[name]?.message as string) || ''
							}
							errorIcon="AlertCircleFilled"
							onChange={field.onChange}
						/>
					)}
				/>
			</div>

			<div className={styles.additionalInfo}>
				<div className={`body-xsmall ${styles.contentSecondaryText}`}>
					{labels.optOutMessage}
				</div>
				<div className="body-xsmall bold">
					{labels.transactionalMessage}
				</div>
			</div>
		</div>
	);
};

export const MarketingOptIn = memo(MarketingOptInInner);

export default MarketingOptIn;
